/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowUploadIcon20Solid = forwardRef('NetCloudArrowUploadIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.25 0a5.502 5.502 0 0 0-5.36 4.265A5.002 5.002 0 0 0 5.5 14H9v4a1 1 0 1 0 2 0v-4h3a5.5 5.5 0 0 0 .151-10.998A5.5 5.5 0 0 0 9.25 0ZM11 14V8.414l1.793 1.793a1 1 0 1 0 1.414-1.414l-2.616-2.616a2.25 2.25 0 0 0-3.182 0L5.793 8.793a1 1 0 1 0 1.414 1.414L9 8.414V14h2Z" })));
});
